import "bootstrap/js/src/collapse";
import "./cart-button";

const mainNav = document.getElementById("main-nav");
const navHeight = mainNav.getBoundingClientRect().height;

window.onscroll = () => {
    var height = document.documentElement.scrollTop;
    if (height > navHeight) {
        mainNav.classList.add("scrolled");
    } else if (height == 0) {
        mainNav.classList.remove("scrolled");
    }
}